<template>
  <div class="container">
    <!-- 头部banner -->
    <top-banner></top-banner>
    <!-- 轮播 -->
    <img src="@/common/images/hardWare/banner_yj.png" class="banner_yj" />
    <!-- 占位撑开 -->
    <div class="zwyj"></div>
    <!-- menu标题栏 -->
    <div class="menu_yj">
      <div class="yj_menu_item" :class="{'yj_menu_item_active':curIndex==0}" @click="changeCur('0')">硬件实力</div>
      <div class="yj_menu_jg"></div>
      <div class="yj_menu_item" :class="{'yj_menu_item_active':curIndex==1}" @click="changeCur('1')">智能环卫硬件</div>
      <div class="yj_menu_jg"></div>
      <div class="yj_menu_item" :class="{'yj_menu_item_active':curIndex==2}" @click="changeCur('2')">智能垃圾分类硬件</div>
      <div class="yj_menu_jg"></div>
      <div class="yj_menu_item" :class="{'yj_menu_item_active':curIndex==3}" @click="changeCur('3')">智能公厕硬件</div>
    </div>
    <!-- 技术与服务深度结合 -->
    <div class="content_yj" id="content_yj">
        <!-- :class="{'animationZoomIn':curIndex==0}" -->
      <img src="../common/images/hardWare/yj_title.png" class="content_yj_title animationZoomIn" />
      <div class="content_yj_line">
        <div class="yj_line_item" v-for="(item,index) in lineList" :key="index" @mouseover="item.show=true"
          @mouseout="item.show=false">
          <img :src="item.imgUrl" class="yj_line_item_img animationZoomInFast" v-show="!item.show" />
        <!-- :class="{'animationZoomInFast':curIndex==0}" -->
          <img :src="item.imgUrl2" class="yj_line_item_img" v-show="item.show" />
        </div>
      </div>
    </div>
    <!-- 智能环卫硬件 -->
    <div class="content_znhw" id="content_znhw">
      <img src="../common/images/hardWare/znhw_bg.png" class="znhw_bg" :class="{'animationRight':curIndex==1}" />
      <img src="../common/images/hardWare/znhw_title.png" class="znhw_title" :class="{'animationZoomIn':curIndex==1}" />
      <img src="../common/images/hardWare/yj_center.png" class="yj_center" :class="{'animationUp':curIndex==1}" />
      <div class="yj_left">
        <div class="yj_item" @mouseover="yjList[0].show=true" @mouseout="yjList[0].show=false"
        @click="showImgC(yjList[0].imgUrl3)">
          <img :src="yjList[0].imgUrl" class="yj_item_img" v-show="!yjList[0].show"
            :class="{'animationBounceIn':curIndex==1 }" />
          <img :src="yjList[0].imgUrl2" class="yj_item_img" v-show="yjList[0].show" />
        </div>
        <div class="yj_item1" @mouseover="yjList[1].show=true" @mouseout="yjList[1].show=false"
        @click="showImgC(yjList[1].imgUrl3)">
          <img :src="yjList[1].imgUrl" class="yj_item_img" v-show="!yjList[1].show"
            :class="{'animationBounceIn':curIndex==1 }" style="animation-delay: 0.1s;" />
          <img :src="yjList[1].imgUrl2" class="yj_item_img" v-show="yjList[1].show" />
        </div>
        <div class="yj_item2" @mouseover="yjList[2].show=true" @mouseout="yjList[2].show=false"
        @click="showImgC(yjList[2].imgUrl3)">
          <img :src="yjList[2].imgUrl" class="yj_item_img" v-show="!yjList[2].show"
            :class="{'animationBounceIn':curIndex==1 }" style="animation-delay: 0.3s;" />
          <img :src="yjList[2].imgUrl2" class="yj_item_img" v-show="yjList[2].show" />
        </div>
      </div>
      <div class="yj_right">
        <div class="yj_item" @mouseover="yjList[3].show=true" @mouseout="yjList[3].show=false"
        @click="showImgC(yjList[3].imgUrl3)">
          <img :src="yjList[3].imgUrl" class="yj_item_img" v-show="!yjList[3].show"
            :class="{'animationBounceIn':curIndex==1 }" />
          <img :src="yjList[3].imgUrl2" class="yj_item_img" v-show="yjList[3].show" />
        </div>
        <div class="yj_item3" @mouseover="yjList[4].show=true" @mouseout="yjList[4].show=false"
        @click="showImgC(yjList[4].imgUrl3)">
          <img :src="yjList[4].imgUrl" class="yj_item_img" v-show="!yjList[4].show"
            :class="{'animationBounceIn':curIndex==1 }" style="animation-delay: 0.1s;" />
          <img :src="yjList[4].imgUrl2" class="yj_item_img" v-show="yjList[4].show" />
        </div>
        <div class="yj_item4" @mouseover="yjList[5].show=true" @mouseout="yjList[5].show=false">
          <img :src="yjList[5].imgUrl" class="yj_item_img" v-show="!yjList[5].show"
            :class="{'animationBounceIn':curIndex==1 }" style="animation-delay: 0.3s;" />
          <img :src="yjList[5].imgUrl2" class="yj_item_img" v-show="yjList[5].show" />
        </div>
      </div>
    </div>
    <!-- 智能垃圾分类硬件 -->
    <div class="content_znljfl" id="content_znljfl">
      <img src="../common/images/hardWare/znljfl_bg.png" class="znljfl_bg" :class="{'animationLeft':curIndex==2}" />
      <img src="../common/images/hardWare/znljfl_title.png" class="znljfl_title"
        :class="{'animationRight':curIndex==2}" />
      <div class="ljfl_content">
        <div class="ljfl_item" @mouseover="ljflList[0].show=true" @mouseout="ljflList[0].show=false">
          <img :src="ljflList[0].imgUrl" class="yj_item_img" v-show="!ljflList[0].show"
            :class="{'animationBounceIn':curIndex==2 }" />
          <img :src="ljflList[0].imgUrl2" class="yj_item_img" v-show="ljflList[0].show" />
        </div>
        <div class="ljfl_item1" @mouseover="ljflList[1].show=true" @mouseout="ljflList[1].show=false"
         @click="showImgC(ljflList[1].imgUrl3)">
          <img :src="ljflList[1].imgUrl" class="yj_item_img" v-show="!ljflList[1].show"
            :class="{'animationBounceIn':curIndex==2 }" style="animation-delay: 0.1s;" />
          <img :src="ljflList[1].imgUrl2" class="yj_item_img" v-show="ljflList[1].show" />
        </div>
        <div class="ljfl_item2" @mouseover="ljflList[2].show=true" @mouseout="ljflList[2].show=false"
        @click="showImgC(ljflList[2].imgUrl3)">
          <img :src="ljflList[2].imgUrl" class="yj_item_img" v-show="!ljflList[2].show"
            :class="{'animationBounceIn':curIndex==2 }" style="animation-delay: 0.3s;" />
          <img :src="ljflList[2].imgUrl2" class="yj_item_img" v-show="ljflList[2].show" />
        </div>
        <div class="ljfl_item3" @mouseover="ljflList[3].show=true" @mouseout="ljflList[3].show=false">
          <img :src="ljflList[3].imgUrl" class="yj_item_img" v-show="!ljflList[3].show"
            :class="{'animationBounceIn':curIndex==2 }" style="animation-delay: 0.5s;" />
          <img :src="ljflList[3].imgUrl2" class="yj_item_img" v-show="ljflList[3].show" />
        </div>
        <div class="ljfl_item4" @mouseover="ljflList[4].show=true" @mouseout="ljflList[4].show=false">
          <img :src="ljflList[4].imgUrl" class="yj_item_img" v-show="!ljflList[4].show"
            :class="{'animationBounceIn':curIndex==2 }" style="animation-delay: 0.5s;" />
          <img :src="ljflList[4].imgUrl2" class="yj_item_img" v-show="ljflList[4].show" />
        </div>
        <div class="ljfl_item5" @mouseover="ljflList[5].show=true" @mouseout="ljflList[5].show=false">
          <img :src="ljflList[5].imgUrl" class="yj_item_img" v-show="!ljflList[5].show"
            :class="{'animationBounceIn':curIndex==2 }" style="animation-delay: 0.3s;" />
          <img :src="ljflList[5].imgUrl2" class="yj_item_img" v-show="ljflList[5].show" />
        </div>
        <div class="ljfl_item6" @mouseover="ljflList[6].show=true" @mouseout="ljflList[6].show=false"
         @click="showImgC(ljflList[6].imgUrl3)">
          <img :src="ljflList[6].imgUrl" class="yj_item_img" v-show="!ljflList[6].show"
            :class="{'animationBounceIn':curIndex==2 }" style="animation-delay: 0.1s;" />
          <img :src="ljflList[6].imgUrl2" class="yj_item_img" v-show="ljflList[6].show" />
        </div>
      </div>

    </div>
    <!-- 智能公厕硬件 -->
    <div class="content_zngc" id="content_zngc">
      <img src="../common/images/hardWare/zngc_bg.png" class="zngc_bg" :class="{'animationRight':curIndex==3}" />
      <img src="../common/images/hardWare/zngc_title.png" class="zngc_title" :class="{'animationLeft':curIndex==3}" />
      <div class="gc_content">
        <div class="gc_item" @mouseover="gcList[0].show=true" @mouseout="gcList[0].show=false">
          <img :src="gcList[0].imgUrl" class="yj_item_img" v-show="!gcList[0].show"
            :class="{'animationBounceIn':curIndex==3 }" />
          <img :src="gcList[0].imgUrl2" class="yj_item_img" v-show="gcList[0].show" />
        </div>
        <div class="gc_item1" @mouseover="gcList[1].show=true" @mouseout="gcList[1].show=false">
          <img :src="gcList[1].imgUrl" class="yj_item_img" v-show="!gcList[1].show"
            :class="{'animationBounceIn':curIndex==3 }" style="animation-delay: 0.1s;" />
          <img :src="gcList[1].imgUrl2" class="yj_item_img" v-show="gcList[1].show" />
        </div>
        <div class="gc_item2" @mouseover="gcList[2].show=true" @mouseout="gcList[2].show=false">
          <img :src="gcList[2].imgUrl" class="yj_item_img" v-show="!gcList[2].show"
            :class="{'animationBounceIn':curIndex==3 }" style="animation-delay: 0.3s;" />
          <img :src="gcList[2].imgUrl2" class="yj_item_img" v-show="gcList[2].show" />
        </div>
        <div class="gc_item3" @mouseover="gcList[3].show=true" @mouseout="gcList[3].show=false">
          <img :src="gcList[3].imgUrl" class="yj_item_img" v-show="!gcList[3].show"
            :class="{'animationBounceIn':curIndex==3 }" style="animation-delay: 0.5s;" />
          <img :src="gcList[3].imgUrl2" class="yj_item_img" v-show="gcList[3].show" />
        </div>
        <div class="gc_item4" @mouseover="gcList[4].show=true" @mouseout="gcList[4].show=false">
          <img :src="gcList[4].imgUrl" class="yj_item_img" v-show="!gcList[4].show"
            :class="{'animationBounceIn':curIndex==3 }" style="animation-delay: 0.3s;" />
          <img :src="gcList[4].imgUrl2" class="yj_item_img" v-show="gcList[4].show" />
        </div>
        <div class="gc_item5" @mouseover="gcList[5].show=true" @mouseout="gcList[5].show=false">
          <img :src="gcList[5].imgUrl" class="yj_item_img" v-show="!gcList[5].show"
            :class="{'animationBounceIn':curIndex==3 }" style="animation-delay: 0.5s;" />
          <img :src="gcList[5].imgUrl2" class="yj_item_img" v-show="gcList[5].show" />
        </div>
        <div class="gc_item6" @mouseover="gcList[6].show=true" @mouseout="gcList[6].show=false">
          <img :src="gcList[6].imgUrl" class="yj_item_img" v-show="!gcList[6].show"
            :class="{'animationBounceIn':curIndex==3 }" style="animation-delay: 0.3s;" />
          <img :src="gcList[6].imgUrl2" class="yj_item_img" v-show="gcList[6].show" />
        </div>
        <div class="gc_item7" @mouseover="gcList[7].show=true" @mouseout="gcList[7].show=false">
          <img :src="gcList[7].imgUrl" class="yj_item_img" v-show="!gcList[7].show"
            :class="{'animationBounceIn':curIndex==3 }" style="animation-delay: 0.1s;" />
          <img :src="gcList[7].imgUrl2" class="yj_item_img" v-show="gcList[7].show" />
        </div>
      </div>
    </div>
    <div class="imgMask" v-show="getImg" @click="getImg=!getImg">
    </div>
    <div class="imgPop" v-show="getImg">
      <img :src="showImg" class="showImg" v-show="getImg" />
      <div class="close_btn" @click="getImg=!getImg"></div>
    </div>

  </div>
</template>

<script>
  import topBanner from '@/components/topBanner.vue'
  export default {
    components: {
      topBanner,
    },
    data() {
      return {
        curPage:'hardWare',
        curIndex: 0,
        getImg: false,
        showImg: '',
        lineList: [{
          imgUrl: require('@/common/images/hardWare/zbzc_1.png'),
          imgUrl2: require('@/common/images/hardWare/zbzc_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/zytd_1.png'),
          imgUrl2: require('@/common/images/hardWare/zytd_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/slgc_1.png'),
          imgUrl2: require('@/common/images/hardWare/slgc_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/jsyy_1.png'),
          imgUrl2: require('@/common/images/hardWare/jsyy_2.png'),
          show: false,
        }],
        yjList: [{
          imgUrl: require('@/common/images/hardWare/yj/yj_l1_1.png'),
          imgUrl2: require('@/common/images/hardWare/yj/yj_l1_2.png'),
          imgUrl3: require('@/common/images/hardWare/tb/tb4.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/yj/yj_l2_1.png'),
          imgUrl2: require('@/common/images/hardWare/yj/yj_l2_2.png'),
          imgUrl3: require('@/common/images/hardWare/tb/tb3.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/yj/yj_l3_1.png'),
          imgUrl2: require('@/common/images/hardWare/yj/yj_l3_2.png'),
          imgUrl3: require('@/common/images/hardWare/tb/tb10.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/yj/yj_r1_1.png'),
          imgUrl2: require('@/common/images/hardWare/yj/yj_r1_2.png'),
          imgUrl3: require('@/common/images/hardWare/tb/tb6.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/yj/yj_r2_1.png'),
          imgUrl2: require('@/common/images/hardWare/yj/yj_r2_2.png'),
          imgUrl3: require('@/common/images/hardWare/tb/tb5.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/yj/yj_r3_1.png'),
          imgUrl2: require('@/common/images/hardWare/yj/yj_r3_2.png'),
          show: false,
        }],
        ljflList: [{
          imgUrl: require('@/common/images/hardWare/ljfl/ljfl_tb1_1.png'),
          imgUrl2: require('@/common/images/hardWare/ljfl/ljfl_tb1_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/ljfl/ljfl_tb2_1.png'),
          imgUrl2: require('@/common/images/hardWare/ljfl/ljfl_tb2_2.png'),
          imgUrl3: require('@/common/images/hardWare/tb/tb11.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/ljfl/ljfl_tb3_1.png'),
          imgUrl2: require('@/common/images/hardWare/ljfl/ljfl_tb3_2.png'),
          imgUrl3: require('@/common/images/hardWare/tb/tb2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/ljfl/ljfl_tb4_1.png'),
          imgUrl2: require('@/common/images/hardWare/ljfl/ljfl_tb4_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/ljfl/ljfl_tb5_1.png'),
          imgUrl2: require('@/common/images/hardWare/ljfl/ljfl_tb5_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/ljfl/ljfl_tb6_1.png'),
          imgUrl2: require('@/common/images/hardWare/ljfl/ljfl_tb6_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/ljfl/ljfl_tb7_1.png'),
          imgUrl2: require('@/common/images/hardWare/ljfl/ljfl_tb7_2.png'),
          imgUrl3: require('@/common/images/hardWare/tb/tb1.png'),
          show: false,
        }],
        gcList: [{
          imgUrl: require('@/common/images/hardWare/gc/gc_tb1_1.png'),
          imgUrl2: require('@/common/images/hardWare/gc/gc_tb1_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/gc/gc_tb2_1.png'),
          imgUrl2: require('@/common/images/hardWare/gc/gc_tb2_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/gc/gc_tb3_1.png'),
          imgUrl2: require('@/common/images/hardWare/gc/gc_tb3_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/gc/gc_tb4_1.png'),
          imgUrl2: require('@/common/images/hardWare/gc/gc_tb4_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/gc/gc_tb5_1.png'),
          imgUrl2: require('@/common/images/hardWare/gc/gc_tb5_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/gc/gc_tb6_1.png'),
          imgUrl2: require('@/common/images/hardWare/gc/gc_tb6_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/gc/gc_tb7_1.png'),
          imgUrl2: require('@/common/images/hardWare/gc/gc_tb7_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/hardWare/gc/gc_tb8_1.png'),
          imgUrl2: require('@/common/images/hardWare/gc/gc_tb8_2.png'),
          show: false,
        }, ]

      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScrollbox, true)
    },
    methods: {
      handleScrollbox() {
        this.currentScroll = window.pageYOffset //表示当前滚动的位置
        var browerWidth = window.innerWidth; //浏览器可视宽度
        var baseWidth = 1920; //设计稿宽度
        var zoomValue = browerWidth / baseWidth; //缩放比例计算
        if (1700 * zoomValue < this.currentScroll && this.currentScroll <= 2300 * zoomValue) {
          this.curIndex = 1
        } else if (2300 * zoomValue < this.currentScroll && this.currentScroll <= 3000 * zoomValue) {
          this.curIndex = 2
        } else if (3000 * zoomValue < this.currentScroll) {
          this.curIndex = 3
        } else {
          this.curIndex = 0
        }
      },
      changeCur(e) {
        this.curIndex = e
        if (e == 0) {
          document.getElementById('content_yj').scrollIntoView()
        } else if (e == 1) {
          document.getElementById('content_znhw').scrollIntoView()
        } else if (e == 2) {
          document.getElementById('content_znljfl').scrollIntoView()
        } else if (e == 3) {
          document.getElementById('content_zngc').scrollIntoView()
        }
      },
      showImgC(e) {
        this.getImg = true
        this.showImg = e
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScrollbox, true)
    }
  }
</script>

<style>
  .container {
    position: relative;
  }

  .banner_yj {
    width: 1920px;
    height: 862px;
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .zwyj {
    width: 1920px;
    height: 862px;
  }

  .menu_yj {
    width: 1920px;
    height: 95px;
    box-shadow: 0px 20px 20px -20px #ededed;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .yj_menu_jg {
    width: 1px;
    height: 36px;
    background: #c3c3c3;
  }

  .yj_menu_item {
    width: 479px;
    line-height: 95px;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    border-top: 10px solid #ffffff;
  }

  .yj_menu_item_active {
    border-top: 10px solid #23adcc;
  }

  .content_yj {
    width: 1920px;
    /* height: 1100px; */
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
  }

  .content_yj_title {
    width: 725px;
    height: 109px;
    margin: 60px auto;
  }

  .content_yj_line {
    width: 1500px;
    margin-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-flow: wrap;
  }

  .yj_line_item {
    width: 615px;
    height: 435px;
    margin: 40px 65px;
  }

  .yj_line_item_img {
    width: 615px;
    height: 435px;
  }

  .content_znhw {
    width: 1920px;
    height: 667px;
    position: relative;
    display: flex;
    flex-direction: row;
  }

  .znhw_bg {
    width: 1920px;
    height: 667px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }

  .znhw_title {
    width: 697px;
    height: 95px;
    position: absolute;
    top: 20px;
    left: 600px;
    z-index: 1;
  }

  .yj_center {
    width: 758px;
    height: 589px;
    position: absolute;
    bottom: -38px;
    left: 578px;
    z-index: 1;
  }

  .yj_left {
    width: 400px;
    height: 400px;
    margin-top: 60px;
    margin-left: 180px;
    position: relative;
    animation-name: bounceInLeft;
    animation-duration: 0.8s;
    z-index: 2;
  }

  .yj_right {
    width: 570px;
    height: 340px;
    margin-top: 100px;
    margin-left: 580px;
    position: relative;
    animation-name: bounceInRight;
    animation-duration: 0.8s;
    z-index: 2;
  }

  .yj_item {
    width: 265px;
    height: 244px;
    position: absolute;
    left: 0;
    top: 0;
  }

  .yj_item1 {
    width: 265px;
    height: 244px;
    position: absolute;
    left: 168px;
    top: 98px;
  }

  .yj_item2 {
    width: 265px;
    height: 244px;
    position: absolute;
    left: -10px;
    top: 192px;
  }

  .yj_item3 {
    width: 265px;
    height: 244px;
    position: absolute;
    left: 152px;
    top: 122px;
  }

  .yj_item4 {
    width: 265px;
    height: 244px;
    position: absolute;
    right: -10px;
    top: 22px;
  }

  .yj_item_img {
    width: 265px;
    height: 244px;
    position: absolute;
  }

  .ljfl_item {
    position: absolute;
    left: 0;
    top: 112px;
  }

  .ljfl_item1 {
    position: absolute;
    left: 172px;
    top: 192px;
  }

  .ljfl_item2 {
    position: absolute;
    left: 196px;
    top: 382px;
  }

  .ljfl_item3 {
    position: absolute;
    left: 352px;
    top: 268px;
  }

  .ljfl_item4 {
    position: absolute;
    left: 516px;
    top: 162px;
  }

  .ljfl_item5 {
    position: absolute;
    left: 526px;
    top: 356px;
  }

  .ljfl_item6 {
    position: absolute;
    left: 689px;
    top: 256px;
  }

  .content_znljfl {
    width: 1920px;
    height: 669px;
    position: relative;
  }

  .ljfl_content {
    width: 900px;
    height: 500px;
    margin-left: 640px;
    margin-right: 380px;
    position: relative;
  }

  .znljfl_bg {
    width: 1920px;
    height: 669px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }

  .znljfl_title {
    width: 428px;
    height: 104px;
    position: absolute;
    top: 60px;
    right: 330px;
    z-index: 1;
  }

  .content_zngc {
    width: 1920px;
    height: 718px;
    position: relative;
  }

  .gc_content {
    width: 900px;
    height: 500px;
    margin-left: 320px;
    margin-right: 700px;
    position: relative;
  }

  .gc_item {
    position: absolute;
    left: 0;
    top: 148px;
  }

  .gc_item1 {
    position: absolute;
    left: 18px;
    top: 340px;
  }

  .gc_item2 {
    position: absolute;
    left: 176px;
    top: 232px;
  }

  .gc_item3 {
    position: absolute;
    left: 194px;
    top: 424px;
  }

  .gc_item4 {
    position: absolute;
    left: 346px;
    top: 132px;
  }

  .gc_item5 {
    position: absolute;
    left: 364px;
    top: 324px;
  }

  .gc_item6 {
    position: absolute;
    left: 530px;
    top: 212px;
  }

  .gc_item7 {
    position: absolute;
    left: 548px;
    top: 404px;
  }

  .zngc_bg {
    width: 1920px;
    height: 718px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }

  .zngc_title {
    width: 428px;
    height: 104px;
    position: absolute;
    top: 36px;
    left: 220px;
    z-index: 1;
  }

  .animationLeft {
    animation-name: bounceInLeft;
    animation-duration: 2s;
  }

  .animationRight {
    animation-name: bounceInRight;
    animation-duration: 2s;
  }

  .animationUp {
    animation-name: bounceInUp;
    animation-duration: 2s;
  }

  .animationDown {
    animation-name: bounceInDown;
    animation-duration: 2s;
  }

  .animationZoomIn {
    animation-name: zoomIn;
    animation-duration: 2s;
  }

  .animationZoomInFast {
    animation-name: zoomIn;
    animation-duration: 1s;
  }

  .animationBounceIn {
    animation-name: bounceIn;
    animation-duration: 1.2s;
    animation-delay: 0.2s;
  }

  @keyframes moveChange {
    from {
      transform: translateY(-30px);
      opacity: 0;
    }

    to {
      transform: translateY(0px);
      opacity: 1;
    }
  }

  .imgMask {
    background-color: #000;
    opacity: 0.3;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    text-align: center;
  }
  .imgPop{
    position: fixed;
    top: 100px;
    left: 325px;
    width: 1271px;
    height: 714px;
    z-index: 99;
    text-align: center;
  }

  .showImg {
    width: 1271px;
    height: 714px;
  }
  .close_btn{
    width:60px;
    height: 60px;
    position: absolute;
    top:0;
    right: 0;
    z-index: 999;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/hardWare.vue